import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { LabTestApi } from '../../../apis/LabTestApi/LabTestApi';
import { IUnit, Unit } from '../../PhysiologicalData/PhysiologicalData';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';

export function useGetLabTestUnits() {
    return useHighFrequencyRefreshQuery<IUnit[]>({
        queryKey: [QueryKeys.labTestUnits],
        queryFn: async () => {
            const results = await LabTestApi.getLabTestUnits();
            return results.map(result => new Unit(result));
        }
    });
} 